<mat-form-field appearance="outline" class="mat-input-custom">
  <mat-label>Contact Number</mat-label>
  <input
    matInput
    formControlName="contact_number"
    appNumbersOnly
    additional_contact="contact_number"
    maxlength="10"
    [readonly]="readonly"
    (input)="onFieldChange()"
  />
  <mat-error *ngIf="form.controls['contact_number']?.hasError('required')">
    This is a required field.
  </mat-error>
  <mat-error *ngIf="form.controls['contact_number']?.hasError('invalidContact')">
    Invalid Contact Number
  </mat-error>
  <mat-error *ngIf="form.controls['contact_number']?.hasError('invalidContactNumber')">
    Please enter a valid Contact number
  </mat-error>
</mat-form-field>
